import { CheckIcon, cn, ErrorMessage } from '@moreharvest/component-library';
import React, { ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';

const toggleClasses = cn(
    'flex justify-center items-center rounded-md w-6 h-6 border-2 shrink-0',
    'border-neutral-300 dark:border-neutral-300-dark cursor-pointer',
    '[&>*]:invisible peer-checked:bg-amber-400 peer-checked:[&>*]:visible peer-checked:border-0',
    'hover:outline-2 hover:outline hover:outline-amber-200',
    'focus-visible:outline-0 focus-visible:ring-amber-200 focus-visible:ring-4'
);

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
    id: string;
    label: ReactNode;
    register?: UseFormRegisterReturn;
    errorMessage?: string;
    'data-cy'?: string;
}

const Checkbox = ({
    id,
    label,
    register,
    errorMessage,
    'data-cy': dataCy,
    ...attributes
}: Props) => {
    return (
        <div className="flex flex-col gap-y-2 items-start">
            <label
                htmlFor={id}
                className="cursor-pointer text-neutral-950 dark:text-neutral-950-dark Body-Small flex w-full items-start gap-x-2
                relative"
                data-cy={dataCy}
            >
                <input
                    type="checkbox"
                    className="peer absolute w-0 h-0 appearance-none"
                    id={id}
                    {...attributes}
                    {...register}
                />
                <div className={toggleClasses}>
                    <CheckIcon className="fill-white  h-8 w-full" />
                </div>

                {label}
            </label>
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </div>
    );
};

export default Checkbox;
